import { faPenLine } from '@fortawesome/pro-regular-svg-icons';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { CalloutBanner, Icon, Text, useRebrand } from '@growtherapy/sprout-ui';

import { VisitorDrawerButton } from '../../VisitorDrawerButton';
import { WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../../constants';
import { VisitorDrawerState } from '../../drawerState';
import { CTAProps } from './PreSessionPrompt';

export function ClientMeasuresCta({ openDrawer }: CTAProps) {
  const t = useTranslate();
  const isRebrand = useRebrand();

  return (
    <CalloutBanner
      use={isRebrand ? 'green' : 'lilac'}
      className='border-none w-fit'
      heading={t('telehealth-core:waitingRoom.takeThisTimeForAMentalHealthCheckIn')}
      headingAs='h2'
      headingVariant='md'
      icon={faPenLine}
      data-testid='pre-session-prompt-client-measures'
    >
      <div className='flex flex-col gap-y-4'>
        <Text>{t('telehealth-core:waitingRoom.theseShortSurveysHelp')}</Text>
        <VisitorDrawerButton
          closedAriaLabel={t('telehealth-core:waitingRoom.openCheckInSurvey')}
          openedAriaLabel={t('telehealth-core:waitingRoom.closeCheckInSurvey')}
          drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
          forDrawerStates={VisitorDrawerState.PENDING_FORMS}
          className='flex gap-4 justify-center items-center w-full'
          onClick={() => openDrawer(VisitorDrawerState.PENDING_FORMS)}
        >
          {t('telehealth-core:waitingRoom.startCheckIn')}
          <Icon aria-hidden icon={faChevronRight} />
        </VisitorDrawerButton>
      </div>
    </CalloutBanner>
  );
}
